import { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import {
  MANUAL_HIDDEN_DAYS,
  MANUAL_HIDE_KEY,
  SESSION_DAYS_DURATION,
  AUTO_HIDE_COUNT,
  AUTO_HIDE_KEY,
} from 'common/constants';

interface UseStretchBannerManualHideReturn {
  isHiddenManual: boolean;
  hideBanner: () => void;
}

export function useStretchBannerManualHide(): UseStretchBannerManualHideReturn {
  const [isHiddenManual, setIsHiddenManual] = useState<boolean>(false);
  const [cookies, setCookies] = useState<Cookies | null>(null);

  useEffect(() => {
    setCookies(new Cookies());
  }, []);

  const removeAutoHideCookies = (): void => {
    if (!cookies) return;

    // Удаляем AUTO_HIDE_COUNT и AUTO_HIDE_KEY куки, если они существуют
    if (cookies.get(AUTO_HIDE_COUNT)) {
      cookies.remove(AUTO_HIDE_COUNT, { path: '/' });
    }

    if (cookies.get(AUTO_HIDE_KEY)) {
      cookies.remove(AUTO_HIDE_KEY, { path: '/' });
    }
  };

  const hideBanner = (event?: React.MouseEvent): void => {
    if (!cookies) return;
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    setIsHiddenManual(true);
    const now = new Date().toISOString();

    removeAutoHideCookies();

    // Устанавливаем MANUAL_HIDE_KEY куку
    cookies.set(MANUAL_HIDE_KEY, now, {
      path: '/',
      expires: new Date(Date.now() + MANUAL_HIDDEN_DAYS * SESSION_DAYS_DURATION),
      sameSite: 'lax',
    });
  };

  useEffect(() => {
    if (!cookies) return;

    const closedAt = cookies.get(MANUAL_HIDE_KEY);

    if (!closedAt) {
      setIsHiddenManual(false);
      return;
    }

    try {
      const closedDate = new Date(closedAt);
      const currentDate = new Date();

      const timeDiff = currentDate.getTime() - closedDate.getTime();
      const daysDiff = timeDiff / (1000 * 3600 * 24);

      if (daysDiff > MANUAL_HIDDEN_DAYS) {
        setIsHiddenManual(false);
        cookies.remove(MANUAL_HIDE_KEY, { path: '/' });
      } else {
        setIsHiddenManual(true);
      }
    } catch (error) {
      console.error('Error parsing cookie date:', error);
      cookies.remove(MANUAL_HIDE_KEY, { path: '/' });
      setIsHiddenManual(false);
    }
  }, [cookies, isHiddenManual]);

  return { isHiddenManual, hideBanner };
}
